import React, { useEffect } from "react";
import dashboardImage from "../../Assets/Images/seekjob/manner.png";
// Import your GIF here. Make sure the path is correct.
import yourGif from "../../Assets/Images/seekjob/dd5291d62e6c9c911a95fa40964687c6b6a8e396.gif"; // <--- IMPORTANT: Replace with your actual GIF path
import sectionBackground from "../../Assets/Images/seekjob/background.png"; // Make sure this path is correct
import intelligentDiscoveryImage from "../../Assets/Images/seekjob/new-frame.png";
import DiscoveryImg from "../../Assets/Images/seekjob/frameimage.png";
import lastOne from "../../Assets/Images/seekjob/last.png";
import endOne from "../../Assets/Images/seekjob/end.png"; // <--- IMPORTANT:
import newOne from "../../Assets/Images/seekjob/Group.png"; // <--- IMPORTANT:
import Button from "./ui/Button";
import { useLocation } from "react-router-dom";
// import intelligentDiscovery from "../../Assets/Images/seekjob/new-frameimage.png"; // <--- IMPORTANT: Replace with your actual path
function OverlapSection() {
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace('#', '');
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) {
          const yOffset = -50; // Adjust to your header height
          const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
          el.scrollIntoView({ top: y, behavior: 'smooth' });
        }
      }, 100); // Delay ensures element is rendered
    }
  }, [location]);
  return (
    <section
      className="tw-relative tw-z-40 tw-pt-[20px] sm:tw-pt-20 tw-px-6 sm:tw-px-10 lg:tw-px-24 tw-bg-white tw-overflow-hidden tw-pb-20"
      style={{
        backgroundImage: `url(${sectionBackground})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
        backgroundRepeat: "no-repeat",
        marginTop: "65px"
      }}
    >
      {/* Background Dotted Pattern - Left */}
      <div className="tw-absolute tw-top-0 tw-left-0 tw-w-48 tw-h-48 tw-bg-[radial-gradient(#e5e7eb_1px,transparent_1px)] tw-bg-[size:16px_16px] tw-opacity-50 tw-z-0"></div>
      {/* Background Dotted Pattern - Bottom Right */}
      <div className="tw-absolute tw-bottom-0 tw-right-0 tw-w-64 tw-h-64 tw-bg-[radial-gradient(#e5e7eb_1px,transparent_1px)] tw-bg-[size:16px_16px] tw-opacity-50 tw-z-0"></div>

      {/* Blue Wave Background Shape - Right */}
      <div className="tw-absolute tw-top-0 tw-right-0 tw-w-[500px] tw-h-[500px] tw-bg-[#E0F2FE] tw-rounded-full tw-transform tw-translate-x-1/2 tw-translate-y-1/4 tw-opacity-70 tw-filter tw-blur-3xl tw-z-0"></div>
      <div className="tw-absolute tw-top-1/4 tw-right-0 tw-w-[400px] tw-h-[400px] tw-bg-[#BFDBFE] tw-rounded-full tw-transform tw-translate-x-1/2 tw-translate-y-1/2 tw-opacity-70 tw-filter tw-blur-3xl tw-z-0"></div>

      <div className="tw-max-w-7xl tw-mx-auto tw-text-center tw-relative tw-z-10">
        {/* Heading */}
        <h2 className="tw-text-[36px] sm:tw-text-[48px] md:tw-text-[60px] lg:tw-text-[66px] tw-font-semibold tw-text-gray-900 tw-leading-tight">
          Our Product {/* The 'Difference' text with concentric rings */}
          <span className="tw-inline-block tw-relative tw-z-10 tw-transform ">
            {/* Innermost dark blue background for the text */}
            <span className="tw-absolute tw-inset-0  tw-rounded-2xl "></span>
            {/* Middle ring - slightly lighter gray/blue */}
            <span className="tw-absolute tw-inset-[-4px]  tw-rounded-2xl tw-opacity-50"></span>
            {/* Outermost ring - slightly darker gray/blue */}
            <span className="tw-absolute tw-inset-[-8px]  tw-rounded-2xl tw-opacity-30"></span>

            {/* The actual 'Difference' text with GIF background */}
            <span
              className="tw-relative tw-inline-block tw-text-white tw-px-6 tw-py-2 tw-rounded-[100px]"
              style={{
                backgroundImage: `url(${yourGif})`, // Set the GIF as background
                backgroundSize: "cover", // Cover the entire span
                backgroundPosition: "center", // Center the GIF
                backgroundRepeat: "no-repeat", // Prevent repeating
              }}
            >
              Difference
            </span>
          </span>
        </h2>

        {/* Subheading */}
        <p

          class="tw-mt-6 tw-text-lg md:tw-text-xl tw-text-black tw-font-bold tw-max-w-3xl tw-mx-auto"
          style={{ marginBottom: "20px" }}
        >
          Each feature is designed to work seamlessly with the others, creating
          a job search experience unlike anything else on the market.
        </p>
      </div>

      {/* Overlapping Card Section */}
      <div className="tw-relative tw-z-50 tw-max-w-4xl tw-mx-auto tw-mt-[0px] tw-rounded-2xl tw-shadow-2xl tw-overflow-hidden">
        {" "}
        {/* Changed from tw-max-w-6xl to tw-max-w-4xl */}
        <img
          src={dashboardImage}
          alt="Dashboard UI"
          className="tw-w-auto tw-max-w-full tw-h-auto tw-rounded-2xl"
        />
      </div>

      {/* NEW SECTION: Intelligent Job Discovery - Right side is now an image */}
      <div

        className="tw-max-w-7xl tw-mx-auto tw-mt-[-80px] sm:tw-mt-[-80px] lg:tw-mt-[-80px] tw-flex tw-flex-col lg:tw-flex-row tw-items-center lg:tw-items-start tw-gap-8 sm:tw-gap-10 lg:tw-gap-12 tw-relative tw-z-10 tw-p-4 sm:tw-p-6 lg:tw-p-8 tw-rounded-2xl tw-pb-0"
        style={{
          background: "linear-gradient(to bottom right,#81BAFD, #F2F2F2)",
          zIndex: 86,
        }}
      >
        {/* Left Content Area */}
        <div className="lg:tw-w-1/2 tw-text-center lg:tw-text-left tw-px-2 sm:tw-px-4 tw-flex tw-flex-col tw-justify-between">
          <div>
            <h3 className="tw-text-[28px] sm:tw-text-[32px] md:tw-text-[36px] tw-font-semibold tw-text-[#235594] tw-leading-tight">
              Intelligent Job Discovery
            </h3>
            <p className="tw-mt-3 sm:tw-mt-4 tw-font-semibold tw-text-[17px] sm:tw-text-[20px] md:tw-text-[23px] tw-text-black">
              Our AI doesn't just match keywords
            </p>
          </div>

          <div >
            <p className="tw-mt-10 sm:tw-mt-16 lg:tw-mt-[178px] tw-text-[17px] sm:tw-text-[20px] md:tw-text-[23px] tw-font-semibold tw-text-gray-800">
              It{" "}
              <span className="tw-text-blue-600">
                understands your potential
              </span>{" "}
              and{" "}
              <span className="tw-text-blue-600">
                connects you with opportunities
              </span>{" "}
              that <br className="hidden sm:inline" />
              actually make sense for your journey.
            </p>
          </div>
        </div>

        {/* Right Content Area */}
        <div className="lg:tw-w-1/2 tw-px-2 sm:tw-px-4 tw-mt-6 lg:tw-mt-0">
          <img
            src={intelligentDiscoveryImage}
            alt="Intelligent Job Discovery Cards"
            className="tw-w-full tw-h-auto tw-object-contain tw-rounded-xl tw-shadow-xl"
          />
        </div>
      </div>
      <div id="resumeEnhancer"></div>
      <div

        className="tw-max-w-7xl tw-mx-auto tw-mt-12 tw-flex tw-flex-col lg:tw-flex-row tw-items-center lg:tw-items-start tw-gap-8 sm:tw-gap-10 lg:tw-gap-12 tw-relative tw-z-10 tw-p-4 sm:tw-p-6 lg:tw-p-8 tw-rounded-2xl tw-pb-0"
        style={{
          background: "linear-gradient(to bottom right,#fff,#fff)",
        }}
      >
        {/* Image Area (Left on desktop, top on mobile) */}
        <div className="lg:tw-w-1/2 tw-px-2 sm:tw-px-4 tw-mt-6 lg:tw-mt-0">
          <img
            src={newOne}
            alt="Intelligent Job Discovery Cards"
            className="tw-w-full tw-h-auto tw-object-contain tw-rounded-xl"
          />
        </div>

        {/* Text Content Area */}
        <div className="lg:tw-w-1/2 tw-text-center lg:tw-text-left tw-px-2 sm:tw-px-4 tw-flex tw-flex-col tw-justify-between">
          {/* Heading + First Paragraph */}
          <div >
            <h3 className="tw-text-[28px] sm:tw-text-[32px] md:tw-text-[36px] tw-font-semibold tw-text-[#235594] tw-leading-tight">
              Instant Resume Optimization
            </h3>
            <p className="tw-mt-3 sm:tw-mt-4 tw-font-semibold tw-text-[17px] sm:tw-text-[20px] md:tw-text-[23px] tw-text-black">
              Transform your application materials in seconds, not hours.
            </p>
          </div>

          {/* Second Paragraph */}
          <div>
            <p className="tw-mt-10 sm:tw-mt-16 lg:tw-mt-[129px] tw-text-[17px] sm:tw-text-[20px] md:tw-text-[23px] tw-font-semibold tw-text-gray-800">
              Our technology ensures you're{" "}
              <span className="tw-text-blue-600">
                always putting your best foot forward.
              </span>
            </p>
          </div>
        </div>
      </div>

      <div
        className="tw-max-w-7xl tw-mx-auto tw-mt-12 tw-flex tw-flex-col lg:tw-flex-row tw-items-center lg:tw-items-start tw-gap-8 sm:tw-gap-10 lg:tw-gap-12 tw-relative tw-z-10 tw-p-4 sm:tw-p-6 lg:tw-p-8 tw-rounded-2xl tw-pb-0"
        style={{
          background: "linear-gradient(to bottom right, #A0DB94, #CAFFBF)",
        }}
      >
        {/* Left Content Area */}
        <div className="lg:tw-w-1/2 tw-text-center lg:tw-text-left tw-px-2 sm:tw-px-4 tw-flex tw-flex-col tw-justify-between">
          <div>
            <h3 className="tw-text-[28px] sm:tw-text-[32px] md:tw-text-[36px] tw-font-semibold tw-text-[#235594] tw-leading-tight">
              Skills Intelligence Engine
            </h3>
          </div>
          <div>
            <p className="tw-mt-10 sm:tw-mt-16 lg:tw-mt-[151px] tw-text-[17px] sm:tw-text-[20px] md:tw-text-[23px] tw-font-semibold tw-text-gray-800">
              Know exactly where you stand and what's next. We{" "}
              <span className="tw-text-blue-600">show you the gaps</span> and the{" "}
              <span className="tw-text-blue-600">fastest path to bridge them.</span>
            </p>
          </div>
        </div>

        {/* Right Content Area (Image) */}
        <div className="lg:tw-w-1/2 tw-px-2 sm:tw-px-4 tw-mt-6 lg:tw-mt-0">
          <img
            src={DiscoveryImg}
            alt="Intelligent Job Discovery Cards"
            className="tw-w-full tw-h-auto tw-object-contain tw-rounded-xl"
          />
        </div>
      </div>


      <div
        className="tw-max-w-7xl tw-mx-auto tw-mt-12 tw-flex tw-flex-col lg:tw-flex-row tw-items-center lg:tw-items-start tw-gap-12 tw-relative tw-z-10 tw-p-8 tw-rounded-2xl tw-pb-0"
        style={{
          background: "linear-gradient(to bottom right, #fff, #fff)",
        }}
      >
        {/* Image Section */}
        <div className="lg:tw-w-1/2 tw-px-4 tw-mt-8 lg:tw-mt-0">
          <img
            src={lastOne}
            alt="Intelligent Job Discovery Cards"
            className="tw-w-full tw-h-auto tw-object-contain tw-rounded-xl"
          />
        </div>

        {/* Text Section */}
        <div className="lg:tw-w-1/2 tw-text-center lg:tw-text-left tw-px-4 tw-flex tw-flex-col tw-justify-between">
          {/* Heading */}
          <div>
            <h3 className="tw-text-[28px] sm:tw-text-[32px] lg:tw-text-[36px] tw-font-semibold tw-text-[#235594] tw-leading-tight">
              Career Command Center
            </h3>
          </div>

          {/* Paragraph */}
          <div>
            <p className="tw-mt-6 sm:tw-mt-10 lg:tw-mt-[126px] tw-font-semibold tw-text-[17px] sm:tw-text-[20px] md:tw-text-[23px] tw-text-black">
              One dashboard that brings clarity to your entire job search journey.
              Finally, know what's working and what isn't.
            </p>
          </div>
        </div>
      </div>

      <div
        className="tw-max-w-7xl tw-mx-auto tw-mt-12 tw-flex tw-flex-col lg:tw-flex-row tw-items-center lg:tw-items-start tw-gap-8 sm:tw-gap-10 lg:tw-gap-12 tw-relative tw-z-10 tw-p-4 sm:tw-p-6 lg:tw-p-8 tw-rounded-2xl tw-pb-0"
        style={{
          background: "linear-gradient(to bottom right,#D9B68C,#FFD6A5)",
        }}
      >
        {/* Left Content Area */}
        <div className="lg:tw-w-1/2 tw-text-center lg:tw-text-left tw-px-2 sm:tw-px-4 tw-flex tw-flex-col tw-justify-between">
          <div>
            <h3 className="tw-text-[28px] sm:tw-text-[32px] md:tw-text-[36px] tw-font-semibold tw-text-[#235594] tw-leading-tight">
              Strategic Network Access
            </h3>
          </div>
          <div>
            <p className="tw-mt-6 sm:tw-mt-10 lg:tw-mt-[239px] tw-text-[17px] sm:tw-text-[20px] md:tw-text-[23px] tw-font-semibold tw-text-gray-800 tw-text-black">
              Connect with the right people at the right time. We make networking feel
              natural, not forced.
            </p>
          </div>
        </div>

        {/* Right Content Area */}
        <div className="lg:tw-w-1/2 tw-px-2 sm:tw-px-4 tw-mt-6 lg:tw-mt-0">
          <img
            src={endOne}
            alt="Intelligent Job Discovery Cards"
            className="tw-w-full tw-h-auto tw-object-contain tw-rounded-xl"
          />
        </div>
      </div>


      {/* End NEW SECTION */}
      {/* End NEW SECTION */}
    </section>
  );
}

export default OverlapSection;
